import { useRef } from "react";
import { Flex, Icon, Select } from "@chakra-ui/react";
import { BiStore } from 'react-icons/bi';
import { useAuth } from "../../hooks/auth";
import { useCart } from "../../hooks/cart";

interface OptionProps {
	value: string;
	label: string;
}
interface SelectCompnayProps {
	options: OptionProps[],
}

export function SelectCompany({ options }: SelectCompnayProps) {
	const companySelectRef = useRef<HTMLSelectElement>(null);

	const { user, company, lojas, setCompany } = useAuth();
	const { cart, addCartMerchant } = useCart();

	function handleCompany(value: any) {
		const indexLoja = lojas.findIndex(loja => loja.id === value); // Number(value));
		setCompany(lojas[indexLoja]);
		addCartMerchant(String(lojas[indexLoja].id), user.comissao);
	};

	return (
		<Flex
			as="label"
			flex="1"
			align="center"
			py="2"
			pl={["1", "1"]}
			pr={["0", "2"]}
			maxWidth={400}
			alignSelf="center"
			color="gray.900"
			position="relative"
		>
			<Icon as={BiStore} fontSize={["12", "22"]} color="blue.100" mt={["1", "0"]} />

			<Select
				isDisabled={!!cart.cliente.id}
				variant="unstyled"
				pl={["1",  "2"]}
				w="auto"
				fontSize={["9", "lg"]}
				fontWeight="bold"
				color="blue.100"
				textTransform="uppercase"
				defaultValue={company?.id}
				ref={companySelectRef}
				_placeholder={{ color: 'gray.400' }}
				_disabled={{
					opacity: 0.6,
					cursor: 'not-allowed'
				}}
				onChange={(e) => handleCompany(e.target.value)}
			>
				<option value="" disabled>Empresas</option>
				{options.map(option => (
					<option key={option.value} value={option.value}>{option.label}</option>
				))}
			</Select>

		</Flex>
	)
}
